var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('public-cancel-booking',{staticClass:"mx-auto",staticStyle:{"max-width":"500px"},attrs:{"calendarId":_vm.calendarId,"eventId":_vm.eventId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }